import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';

import { ComponentType } from '@angular/cdk/portal';
import { Injectable } from '@angular/core';
import { MessageModalComponent } from '../../shared/modals/message-modal/message-modal.component';
import { ConfirmationDialogComponent } from '../../shared/modals/confirmation-modal/confirmation-modal.compnent';

@Injectable({ providedIn: 'root' })
export class DialogService {
  
  constructor(private dialog: MatDialog) {}

  public get isDialogOpen(): boolean {
    return this.dialog.openDialogs.length > 0;
  }

  public get isNestedDialogOpen(): boolean {
    return this.dialog.openDialogs.length > 1;
  }

  public get openedDialogsCount(): number {
    return this.dialog.openDialogs.length;
  }

  public open<T, D = any, R = any>(
    component: ComponentType<T>,
    config?: MatDialogConfig<D>
  ): MatDialogRef<T, R> | null {
    return this.isDialogOpen ? null : this.dialog.open(component, config);
  }

  public openNestedModal<T, D = any, R = any>(
    component: ComponentType<T>,
    config?: MatDialogConfig<D>
  ): MatDialogRef<T, R> {
    return this.dialog.open(component, config);
  }

  public openModal(
    message: string,
    type: 'error' | 'info' = 'error',
    nestedModal?: boolean
  ): MatDialogRef<MessageModalComponent> | null {
    const config = {
      data: {
        message,
        type: type,
      },
      panelClass: 'modal',
      position: { top: '30px' },
      autoFocus: 'disable',
    };

    return nestedModal
      ? this.openNestedModal(MessageModalComponent, config)
      : this.open(MessageModalComponent, config);
  }

  public closeAllModals(): void {
    this.dialog.closeAll();
  }

  public showConfirmation(
    message: string,
    confirmButtonText: string,
    cancelButtonText: string,
    nestedModal?: boolean
  ): MatDialogRef<ConfirmationDialogComponent> | null {
    const config = {
      data: {
        message: message,
        confirmButtonText: confirmButtonText ? confirmButtonText : 'Ok',
        cancelButtonText: cancelButtonText ? cancelButtonText : 'Cancel',
      },
      panelClass: 'modal',
      position: { top: '30px' },
      autoFocus: 'disable',
    };
    return nestedModal
      ? this.openNestedModal(ConfirmationDialogComponent, config)
      : this.open(ConfirmationDialogComponent, config);
  }

}
